/* eslint-disable camelcase */
import React from 'react'
import useSelector from 'hooks/use-selector'
import shouldShowOnlyFewLeftVariantSelector from 'modules/variant/redux/selectors/should-show-only-few-left'
import ChipRectangle from 'components/ChipRectangle'
import { ONLY_FEW_LEFT } from 'modules/variant/constants'

// const ANALYTICS_EVENT = {
//   SHOW_ONLY_FEW_BADGE_LEFT_BADGE: 'SHOW_ONLY_FEW_BADGE_LEFT_BADGE'
// }

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadgeOnlyFewLeft (props) {
  const { variantId, isSample } = props
  const shouldShow = useSelector(
    shouldShowOnlyFewLeftVariantSelector({ variantId, isSample })
  )

  React.useEffect(() => {
    // if (shouldShow) {
    //   logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_ONLY_FEW_BADGE_LEFT_BADGE)
    // }
  }, [shouldShow])

  if (!shouldShow) {
    return <></>
  }

  return (
    <ChipRectangle>
      {ONLY_FEW_LEFT}
    </ChipRectangle>
  )
}
